import { Routes } from '@angular/router';
import { AdminDashboardComponent } from './features/admin/pages/admin-dashboard/admin-dashboard.component';
import { CustomerManagementComponent } from './features/management/pages/customer-management/customer-management.component';
import { IntegrationManagementComponent } from './features/management/pages/integration-management/integration-management.component';
import { AddCustomerComponent } from './features/management/pages/customer-management/add-customer/add-customer.component';
import { AddIntegrationComponent } from './features/management/pages/integration-management/add-integration/add-integration.component';
import { UserLoginComponent } from './features/login/pages/user-login/user-login.component';
import { LoginLayoutComponent } from './layout/login-layout/login-layout.component';
import { MainLayoutComponent } from './layout/main-layout/main-layout.component';
import { NotAuthorizedGuard } from './core/guards/not-auth.guard';
import { EditCustomerDetailsComponent } from './features/management/pages/customer-management/edit-customer-details/edit-customer-details.component';
import { CustomerDetailsComponent } from './features/management/pages/customer-management/customer-details/customer-details.component';
import { IntegrationDetailsComponent } from './features/management/pages/integration-management/integration-details/integration-details.component';
import { EditIntegrationDetailsComponent } from './features/management/pages/integration-management/edit-integration-details/edit-integration-details.component';
import { ScopesGuard } from './core/guards/scopes.guard';
import { EmployeeManagementComponent } from './features/management/pages/employee-management/employee-management.component';
import { AuthorizedGuard } from './core/guards/auth.guard';
import { organizationsAllowedAccess } from './core/guards/allowed-orgs.guard';
import { AddEmployeeComponent } from './features/management/pages/employee-management/add-employee/add-employee.component';
import { EditEmployeeDetailsComponent } from './features/management/pages/employee-management/edit-employee-details/edit-employee-details.component';
import { ParentIntegrationManagementComponent } from './features/management/pages/parent-integration-management/parent-integration-management.component';
import { AddParentIntegrationComponent } from './features/management/pages/parent-integration-management/add-parent-integration/add-parent-integration.component';
import { ParentIntegrationDetailsComponent } from './features/management/pages/parent-integration-management/parent-integration-details/parent-integration-details.component';
import { EditParentIntegrationDetailsComponent } from './features/management/pages/parent-integration-management/edit-parent-integration-details/edit-parent-integration-details.component';

export const routes: Routes = [
  {
    path: 'logout',
    loadComponent: () =>
      import('./features/logout/pages/user-logout/user-logout.component').then(
        (m) => m.UserLogoutComponent
      ),
  },
  {
    path: '',
    component: LoginLayoutComponent,
    canActivate: [NotAuthorizedGuard],
    children: [
      { path: '', redirectTo: 'login', pathMatch: 'full' },
      { path: 'login', component: UserLoginComponent },
    ],
  },
  {
    path: '',
    component: MainLayoutComponent,
    canActivate: [AuthorizedGuard, ScopesGuard],
    children: [
      { path: 'dashboard', component: AdminDashboardComponent },

      {
        path: 'customer-management',
        children: [
          { path: 'overview', component: CustomerManagementComponent },
          {
            path: 'add-customer',
            canMatch: [
              /* Only AssetWorks employees should be able to ADD new customers.
              Integration partner employees should not have access to do this */
              organizationsAllowedAccess(
                ['assetworks-employee'],
                'customer-management/overview'
              ),
            ],
            component: AddCustomerComponent,
          },
          {
            path: 'customer-details/:customerId',
            component: CustomerDetailsComponent,
          },
          {
            path: 'customer-details/:customerId/edit',
            canMatch: [
              /* Only AssetWorks employees should be able to ADD new customers.
              Integration partner employees should not have access to do this */
              organizationsAllowedAccess(
                ['assetworks-employee'],
                'customer-management/overview'
              ),
            ],
            component: EditCustomerDetailsComponent,
          },
        ],
      },

      {
        path: 'parent-integration-management',
        children: [
          {
            path: 'overview',
            canMatch: [
              organizationsAllowedAccess(
                ['assetworks-employee'],
                'dashboard'
              ),
            ],
            component: ParentIntegrationManagementComponent,
          },
          {
            path: 'add-parent-integration',
            canMatch: [
              organizationsAllowedAccess(
                ['assetworks-employee'],
                'parent-integration-management/overview'
              ),
            ],
            component: AddParentIntegrationComponent,
          },
          {
            path: 'parent-integration-details/:parentIntegrationId',
            component: ParentIntegrationDetailsComponent,
          },
          {
            path: 'parent-integration-details/:parentIntegrationId/edit',
            component: EditParentIntegrationDetailsComponent,
          },
        ],
      },

      {
        path: 'integration-management',
        children: [
          {
            path: 'overview',
            component: IntegrationManagementComponent,
          },
          {
            path: 'add-integration',
            /* Only AssetWorks employees should be able to ADD new integrations.
              Integration partner employees should not have access to do this */
            canMatch: [
              organizationsAllowedAccess(
                ['assetworks-employee'],
                'integration-management/overview'
              ),
            ],
            component: AddIntegrationComponent,
          },
          {
            path: 'integration-details/:integrationId',
            component: IntegrationDetailsComponent,
          },
          {
            path: 'integration-details/:integrationId/edit',
            component: EditIntegrationDetailsComponent,
          },
        ],
      },

      {
        path: 'employee-management',
        children: [
          { path: 'overview', component: EmployeeManagementComponent },
          {
            path: 'add-employee',
            canMatch: [
              organizationsAllowedAccess(
                ['assetworks-employee'],
                'employee-management/overview'
              ),
            ],
            component: AddEmployeeComponent,
          },
          {
            path: 'employee-details/edit',
            canMatch: [
              organizationsAllowedAccess(
                ['assetworks-employee'],
                'employee-management/overview'
              ),
            ],
            component: EditEmployeeDetailsComponent,
          },
        ],
      },
    ],
  },
  { path: '**', redirectTo: 'login' },
];
